export const onboardingTargets = {
  overview: 'overview-nav-anchor',
  trackingOverview: 'tracking-overview-nav-anchor',
  affiliateGainz: 'affiliate-gainz-nav-anchor',
  publisherSettings: 'publisher-settings-nav-anchor',
};
